import { Pencil } from "lucide-react"
import { HoverTooltip } from "@/app/components/HoverTooltip"
import type { ClientTheme } from "@/app/lib/themes"

// Compact "manually edited" indicator — a pencil chip shown on rows whose
// app_edited_at is set (edited in-app, so the importer will not overwrite them).
// Shared by the desktop row and the mobile card so both read identically.
export function EditedBadge({ theme }: { theme: ClientTheme }) {
  return (
    <HoverTooltip content="Manually edited — will not be overwritten by imports" theme={theme}>
      <span
        aria-label="Manually edited"
        className="inline-flex items-center justify-center"
        style={{
          width: "18px",
          height: "18px",
          borderRadius: "9999px",
          color: theme.brandPrimary,
          backgroundColor: `${theme.brandPrimary}1F`,
          border: `1px solid ${theme.brandPrimary}3D`,
          flexShrink: 0,
        }}
      >
        <Pencil size={10} strokeWidth={2.25} />
      </span>
    </HoverTooltip>
  )
}
